export default {
  home: {
    title: '首页',
    customerService: '咨询热线',
    email: '邮箱',
    eventTicketPurchase: '赛事购票',
    eventVenues: '赛事场馆',
    eventSearch: '赛事搜索',
    ticketHolderNotice: '持票须知',
    ticketNotice: '票务公告',
    helpCenter: '帮助中心',
    registerNow: '立即注册',
    turn: '转'
  },
  show:{
    title: '演出详情',
    audience: '观演人',
  },
  order:{
    refunding:'退票中',
    refunded:'已退票',
    idType: '证件类型',
    idNumber: '证件号码',
    pageHome: '首页',
    pageCenter: '个人中心',
    pageOrder: '我的订单',
    pageOrderNo: '订单号:',
    payleft: '支付剩余',
    topay: '去支付',
    noOrder: '暂无订单',
    present:'转赠',
    myOrder: '我的订单',
    address: '收货地址',
    orderNo: '订单号',
    createTime: '下单时间',
    orderDetail: '订单详情',
    orderTipFirst: '请在',
    orderTipLast: '内完成付款，超时将自动取消订单',
    seatPlanUnit: '张',
    orderInfo: '订单信息',
    viewTicket: '查看取票码',
    viewTicket2: '查看电子票',
    ticketDesc: '请扫码使用微信小程序查看取票码',
    waitPay: '待支付',
    cancelOrder: '取消订单',
    audience: '观演人',
    deliverMethod: '配送方式',
    ticketIntro: '取票说明',
    viewExpress: '查看物流信息',
    payInfo: '付款信息',
    payMethod: '支付方式',
    payTime: '下单时间',
    applyInvoice: '申请开票',
    applyInvoiced: '查看开票',
    orderDetails: '订单明细',
    orderTotal: '合计',
    orderCancel: '确认取消订单吗？',
    success: '提交成功'
  },
  payment: {
    select_pay_way:'选择支付方式',
    quick_pay_money:'请您尽快完成支付',
    your_order_created:'您的订单已生成',
    order_auto_close:'后将自动关闭',
    scan_pay:'扫一扫付款（元）',
    open_phone:'请打开手机',
    open_phone_on: '',
    scan_finish_pay:'扫一扫完成支付',
    pay_now:'立即支付',
    weixin:'微信',
    zhifubao:'支付宝',
    unitePay: '微信/支付宝',
    eRmb: '数字人民币工行钱包',
  },
  invoice: {
    invoiceType: '发票类型',
    invoiceTitleType: '抬头类型',
    invoiceTitle: '发票抬头',
    invoiceAmount: '开票金额',
    taxpayerId: '税号',
    bankName: '开户银行',
    bankAccount: '银行账号',
    address: '企业地址',
    phoneNo: '企业电话',
    invoiceContentType: '发票内容',
    applyTime: '申请日期',
    invoiceContentDesc: '体育服务',
    INDIVIDUAL_OR_INSTITUTION: '个人或事业单位',
    ENTERPRISE: '企业',
    VAT_E_ORDINARY: '增值税电子普通发票',
    expressInfo: '物流信息',
    expressTel: '物流电话',
    application: '申请开票',
    invoiceType_placeholder: '请选择发票类型',
    invoiceTitle_placeholder: '请填写发票抬头',
    invoiceTitle_placeholder_name: '请填写开具发票的姓名',
    invoiceTitle_placeholder_header: '请填写开具发票的抬头',
    taxpayerId_placeholder: '请填写税号',
    taxpayerId_placeholder_nasuiren: '请填写纳税人识别号',
    optional: '选填',
    application_confirm: '申请确认',
    orderNumber: '订单编号',
    price_tip: '开票金额为购票人实付款金额，如为纸质票则包含快递费用。如订单发生退货退款，开票金额将变更为最终实付款金额。',
    confirm_text: '提交确认后无法修改申请发票内容，请确认相关信息',
    content_tip: '发票内容将显示详细项目名称与价格信息。如有特殊需求，请咨询官方票务咨询热线；',
    submit: '提交申请',
    back: '返回修改',
    confirm: '确认提交',
    details: '开票详情',
    repply: '重新申请',
    save: '保存发票',
    APPLYING: '申请中',
    APPLYING_DESC: '待申请开票审核通过后可查看发票',
    REJECTED: '已驳回',
    REJECTED_DESC: '该订单开票申请已驳回，驳回理由：',
    SUCCESS: '已开票',
    SUCCESS_DESC: '该订单已开具发票',
  },
  system: {
    goHome: '返回北京天桥艺术中心首页',
    userCenter: '个人中心',
    delete_title: "确认是否删除？",
    confirm: "确定",
    see_agine: "再想想",
    leftBookPunctuation: "《",
    rightBookPunctuation: "》",
    title: "北京天桥艺术中心购票官网",
    wechat: "微信",
    alipay: "支付宝",
    money_unit: "¥",
    relogin_comment: "登录失效，请重新登录",
  },
  loginModal: {
    title: '登录',
    login: '登录',
    loging: '登录中...',
    logout: '退出登录',
    pleaseEnterCellPhone: '请输入手机号码',
    pleaseEnterGoodCellphone: '请输入正确的手机号码',
    pleaseEnterImageCode: '请输入图形验证码',
    pleaseEnterSmsCode: '请输入验证码',
    getSmsCode: '获取验证码',
    readAgree: '已阅读并同意',
    readAgree2: '中的全部条款',
    pleaseCheckPolicy: '请勾选协议',
    confirm: '同意',
    notConfirm: '不同意',
    and: '和',
  },
  address: {
    add: '新增地址',
    edit: '编辑',
    delete: '删除',
    default: '默认地址',
    no_address: '暂无收货地址',
    dialog_edit_title: '编辑收货地址',
    dialog_add_title: '新增收货地址',
    username: '收件人',
    cellphone: '手机号',
    province: '省',
    city: '市',
    district: '区',
    detailAddress: '详细地址',
    setToDefault: '设为默认',
    username_placeholder: '请填写收件人',
    cellphone_placeholder: '请填写手机号',
    province_placeholder: '请选择省',
    city_placeholder: '请选择市',
    district_placeholder: '请选择地区',
    detailAddress_placeholder: '请填写详细地址',
    detailAddress_rule: '地址最少输入6个字',
    cellphone_rule: '请输入正确的手机号码',
    setToDefault2: '设为默认地址',
    delete_dialog_content: '确认是否删除？',
  },
  audience: {
    add: '新增观演人',
    edit: '编辑',
    delete: '删除',
    no_audience: '暂无观演人',
    dialog_edit_title: '编辑观演人',
    dialog_add_title: '新增观演人',
    name: '姓名',
    idType: '证件类型',
    idNo: '证件号码',
    name_placeholder: '请填写姓名',
    idType_placeholder: '请选择证件类型',
    idNo_placeholder: '请填写证件号',
    know: '知道了',
    attention: '实名须知',
    attention_text_one: '点击保存即表示您已阅读并同意',
    attention_text_two: '',
    attention_content: '根据法律规定及国内公安部门对大型活动中购票用户或观演用户实名制的要求,实名制的项目在购票时需要提供你的实名信息,包括姓名和身份证。为了方便您迅速下单,您可选择在购票前提前添加或在购票过程中提交。为保证信息的真实性和唯一性,我们会基于您所提供的信息通过征信平台或其他惯常方式进行实名认证。',
    country: '国家地区',
    country_placeholder: '请选择国家地区',
    delete_dialog_content: '确认是否删除？',
  },
  hot: {
    main_title: '正在热抢',
    minor_title: '即将开抢',
    support_seat: '可选座',
    grab_votes: '去抢票',
    on_sale: '开售',
    day: '天',
  },
  list: {
    main_title: '',
    minor_title: '推荐',
    support_seat: '可选座',
    grab_votes: '去抢票',
    on_sale: '开售',
    day: '天',
    calendar: '赛事日历',
    monday: '周一',
    tuesday: '周二',
    wednesday: '周三',
    thursday: '周四',
    friday: '周五',
    saterday: '周六',
    sunday: '周日',
    no_result_1: '暂时没有“',
    no_result_2: '”的搜索结果',
    today: '今天',
  },
  pickseat: {
    text_selected_seats: '已选座位',
    btn_text_confirm_seats: '确认选座',
    text_acmount_to: '合计',
    text_unit: '张',
    text_count: '共',
    text_discount_info: '套票优惠',
    btn_text_clear_seats: '清空',
    text_discount_title: '优惠信息',
    btn_text_back:'回到全局',
    change_session: '切换场次',
    select_default_session: '选择一个场次',
    you_selected_seat:'您已选择',
    combo_unit_name: '套',
    ticket_sale_out: '售罄',
    over_limit_num: '超出该票价最大数量了哦'
  },
  content: {
    time: '时间',
    venue: '场馆',
    date: '日期',
    session_name: '场次',
    ticket_name: '票价',
    ticket_number: '数量',
    service_name: '服务',
    delay_tag: '延期',
    tag_tao: '套',
    lack_tag: '缺票登记',
    has_lacked_tag: '已提交缺票登记',
    pending_name_tag: '开售提醒',
    not_yet_for_sale: '暂未开售',
    has_pending_name_tag: '已设置提醒',
    buy_now: '立即购买',
    go_pick_seat: '选座购票',
    show_delay: '赛事延期',
    show_has_over: '该项目已结束',
    show_has_cancel: '该项目已取消',
    home: '首页',
    list: '列表',
    show_detail: '项目详情',
    service_name_tips: '服务说明',
    event_announcement: '赛事公告',
    ticket_purchase_notice: '购票须知',
    observation_tips: '观演须知',
    observation_notice: '观演须知',
    specific_on_site_conditions: '具体以现场为准',
    yuan_unit: '元',
    cancel_remind: '取消提醒',
    add_remind: '添加提醒',
    day: '天',
    success_set_ticket_snatching: '设置抢票提醒成功',
    remind_SMS_5min: '将在开售5分钟通过短信提醒您',
    know: '知道了',
    register_success: '登记成功',
    have_ticket_to_notice_first_time: '我们将在有票后第一时间通知您',
    remind_success: '开售提醒成功',
    sale_ticket_to_notice_first_time: '我们将在开售后第一时间通知您',
    buy_limition_desc: '已达购买上限',
    preview_tip: '预览模式，禁止操作'
  },
  confirm: {
    selected_seats: '已选座位',
    fill_in_order_information: '填写订单信息',
    success_submit_order: '成功提交订单',
    order_error: '下单失败',
    please_add_address: '请添加收获地址',
    confirm_order: '确认订单',
    express_name: '运费',
    one_unit: '个',
    spectator: '观演人',
    deliver_method: '配送方式：',
    deliver_method2: '配送方式',
    need_add: '还需要添加',
    express_method: '纸质票 (快递)',
    express_unit: '运费',
    is_express: '快递送票：',
    pay_pirce: '应付总额：',
    sumbit_name: '提交订单',
    real_name_observer: '实名观演人',
    observer: '观演人',
    add_observer: '新增观演人',
    no_observer: '暂无观演人',
    entry_requires_corresponding_documents: '入场需携带相应证件',
    selected: '已选',
    unm_unit: '位，',
    document_type: '证件类型：',
    identification_number: '证件号码：',
    add_shipping_address: '新增收货地址',
    no_shipping_address: '暂无收货地址',
    ticket_collection_instructions: '取票说明：',
    confirm_order_information: '确认订单信息',
    amount_to: '合计',
    caombo_name: '套票:',
    caombo_discount_name: '套票优惠：',
    tao_tag: '套',
    zhang_tag: '张',
    tag_all: '共',
    slow_ticket_loot: '手慢了一步，票被抢走啦',
    back: '返回',
    pick_other_seat: '选择其他座位试试',
    express_delivery_pay: '寄付',
    scene_pay: '到付',
    create_order_pay_express_fee: '下单时用户支付快递费',
    on_site_receipt_pay_express_fee: '快递签收时支付快递费，费用以实际签收时为准',
  },
  dialog: {
    save: '保存',
    cancel: '取消',
    aware_and_agree: '我已知晓并同意',
    slide_all_text: '滑动阅读全文',
  },
  error: {
    error_message: '出了点小问题，请返回稍后再试',
  },
  ticket_paid: {
    order_success: '支付成功',
    view_order: '查看订单',
    order_back: '返回',
  }
}
